export default {
    'groups': [{
        'label': 'wrist_level_of_interest',
        'points': 2,
        'connectivity':
        ['0 1',
        '1 0',
    ]
    }, {
        'label': 'card_corners',
        'points': 4,
        'connectivity':
        ['0 1',
        '1 2',
        '2 3',
        '3 0',
    ]
    }]
};



// WEBPACK FOOTER //
// ./src/js/app/template/hand.js